module.exports = __webpack_public_path__ + "static/media/great-full.4075b2d6.png";